<template>
  <div class="container">
    <div class="title-parent">
        <span class="title title-parent">
          <h1>{{ $t('home.apiProducts.title') }}</h1>
        </span>
    </div>
    <div>
      <div class="row margin-bottom-3--clear">
        <div
            class="col-xs-12 col-lg-6 col-xl-4 margin-bottom-2"
            v-for="product in productCards"
            :key="product.cardTitle"
        >
          <sdx-card
              :label="product.cardTitle"
              :hidden="product.cardHidden"
              label-aria-level="2"
              class="sdx-card"
          >
            <p :id="product.id +'-text'" class="productText margin-bottom-2">
              {{ product.cardText }}
            </p>
            <p class="margin-bottom-2" v-html="product.cardSecondText" />

            <!-- eslint-disable-next-line vue/no-deprecated-slot-attribute -->
            <sdx-button-group layout="fullwidth" class="sdx-button-home-direction text-align-bottom" slot="interaction">
              <sdx-button
                  :id="product.id +'-button-product'"
                  name="goToProductSite"
                  :label="this.$t('home.apiProducts.buttonText.product')"
                  @click="visitProduct(product.id)"
                  v-if="!loggedIn || !product.hasSubscription"
              ></sdx-button>
              <sdx-button
                  :id="product.id +'-button-subscription'"
                  name="goToProductSubscription "
                  :label="this.$t('home.apiProducts.buttonText.subscription')"
                  @click="gotoSubscription(product.id)"
                  v-if="loggedIn && product.hasSubscription"
              ></sdx-button>
            </sdx-button-group>
          </sdx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurrentLanguage} from "@/i18n/i18n";
import userService from "@/services/user.service";
import envService from "@/services/env.service";


export default {
  data() {
    return {
     loggedIn: false
    }
  },
  computed: {
    productCards() {
      return [
        {
          id: "productCardSms",
          cardTitle: this.$t('home.apiProducts.sms.title'),
          cardIcon: 'icon-sms',
          cardText: this.$t('home.apiProducts.sms.text'),
          cardSecondText: this.$t('home.apiProducts.sms.secondText'),
          cardProductRoute: 'https://digital.swisscom.com/products/text-messaging',
          hasSubscription: userService.hasRightSms(),
          cardSubscriptionRoute: 'https://digital.swisscom.com/my/subscriptions',
          cardHidden: !envService.featureToggleStats()
        },
        {
          id: "productCardValidation",
          cardTitle: this.$t('home.apiProducts.validation.title'),
          cardIcon: 'icon-sms',
          cardText: this.$t('home.apiProducts.validation.text'),
          cardSecondText: this.$t('home.apiProducts.validation.secondText'),
          cardProductRoute: 'https://digital.swisscom.com/products/phone-number-validation',
          hasSubscription: userService.hasRightSms(),
          cardSubscriptionRoute: 'https://digital.swisscom.com/my/subscriptions',
          cardHidden: !envService.featureToggleStats()
        },
        {
          id: "productCardReceiveSms",
          cardTitle: this.$t('home.apiProducts.receiveSms.title'),
          cardIcon: 'icon-inbox-2',
          cardText: this.$t('home.apiProducts.receiveSms.text'),
          cardSecondText: this.$t('home.apiProducts.receiveSms.secondText'),
          cardProductRoute: 'https://digital.swisscom.com/products/receive-sms',
          hasSubscription: userService.hasRightReceiveSms(),
          cardSubscriptionRoute: 'https://digital.swisscom.com/my/subscriptions',
          cardHidden: !envService.featureToggleSmsInbox()
        },
        {
          id: "productCardCampaign",
          cardTitle: this.$t('home.apiProducts.campaign.title'),
          cardIcon: 'icon-smartphones-multiple',
          cardText: this.$t('home.apiProducts.campaign.text'),
          cardSecondText: this.$t('home.apiProducts.campaign.secondText') + (envService.featureToggleQuickGuide()?this.$t('home.apiProducts.campaign.quickguide'):""),
          cardProductRoute: 'https://digital.swisscom.com/products/campaigns-internal',
          hasSubscription: userService.hasRightCampaignManager(),
          cardSubscriptionRoute: 'https://digital.swisscom.com/my/subscriptions',
          cardHidden: !envService.featureToggleCampaign()
        },
      ]
    },
  },
  created() {
    this.$i18n.locale = getCurrentLanguage()
    this.loggedIn=userService.isLoggedIn()
  },
  methods: {
    hasRight(right){
      return userService.hasRight(right)
    },
    visitProduct(id) {
      let urlProduct = this.productCards.filter((product) => product.id === id);
      let url = urlProduct[0].cardProductRoute;
      window.open(url, '_blank');
    },
    gotoSubscription(id) {
      let urlProduct = this.productCards.filter((product) => product.id === id);
      let url = urlProduct[0].cardSubscriptionRoute;
      window.open(url, '_blank');
    },
  },
}
</script>

<style scoped>
.title-parent {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 2rem;
  padding: 4rem 0 4rem 0;
}

.title {
  animation-name: color;
  animation-duration: 20s;
  animation-iteration-count: infinite;
  position: absolute;
  width: 100%;
  left: 0;
  height: 20%;
  color: white;
  background-image: url("~@/assets/violetblue.jpg");
  background-size: cover;
  background-color: rgb(8, 106, 219);
}

.productText {
  font-weight: bold;
}

</style>
